/**
 * Map utility functions
 */

// Get status color for markers
export const getStatusColor = (status) => {
  switch (status) {
    case "DELIVERED":
      return "#10B981"; // Green
    case "IN_DELIVERY":
      return "#F59E0B"; // Yellow
    case "SCHEDULED":
      return "#3B82F6"; // Blue
    case "MISSED":
      return "#EF4444"; // Red
    default:
      return "#6B7280"; // Gray
  }
};

// Get status text for display
export const getStatusText = (status, t) => {
  const statusMap = {
    DELIVERED: t("scheduleMap.delivered"),
    IN_DELIVERY: t("scheduleMap.inDelivery"),
    SCHEDULED: t("scheduleMap.scheduled"),
    MISSED: t("scheduleMap.missed"),
  };
  return statusMap[status] || status;
};

// Validate coordinates
export const isValidCoordinate = (coord) => {
  const num = parseFloat(coord);
  return !isNaN(num) && isFinite(num);
};

// Safe coordinate parsing
export const safeParseCoordinate = (coord, fallback = 0) => {
  const parsed = parseFloat(coord);
  return isValidCoordinate(parsed) ? parsed : fallback;
};
